import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_GDPR_PROFILE_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import GdprProfile from '../../components/GdprProfile';

export const Route = createFileRoute('/_authenticated/gdpr-profile/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_PROFILE_LIST, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.gdprProfiles',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GdprProfileRoute,
});

function GdprProfileRoute() {
  return <GdprProfile />;
}
